import React from 'react';
import { PhotoTimeline } from './PhotoTimeline';
export function Hero() {
  return <section id="domov" className="pt-32 pb-16 md:pt-40 md:pb-24 px-6 scroll-mt-24" data-id="element-56">
      <div className="max-w-4xl mx-auto text-center" data-id="element-57">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-medium mb-6 leading-tight" data-id="element-58">
          70 let in še brca
        </h1>

        <div className="flex items-center justify-center gap-4 mb-8" data-id="element-59">
          <div className="h-px w-12 bg-gold/50" data-id="element-60"></div>
          <h2 className="text-xl md:text-2xl tracking-[0.3em] font-sans font-medium text-gold" data-id="element-61">
            DANI SITER
          </h2>
          <div className="h-px w-12 bg-gold/50" data-id="element-62"></div>
        </div>

        <p className="text-lg md:text-xl max-w-2xl mx-auto leading-relaxed text-soft-brown/90 font-light" data-id="element-63">
          Pridite, da skupaj s hvaležnostjo proslavimo vse doživeto in ustvarimo
          nove spomine.
        </p>
      </div>

      <PhotoTimeline data-id="element-64" />
    </section>;
}